import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Avatar,
  useTheme,
  Skeleton
} from '@mui/material';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import { Typewriter } from 'react-simple-typewriter';

type InsightCardProps = {
  title: string;
  content: string;
  loading?: boolean;
};

const InsightCard: React.FC<InsightCardProps> = ({ title, content, loading = false }) => {
  const theme = useTheme();

  const linhas = content
    .split(/(?=\d+\. Produto)/)
    .filter((l) => l.trim() !== '');

  const [linhasVisiveis, setLinhasVisiveis] = useState<number>(0);

  useEffect(() => {
    if (linhasVisiveis < linhas.length) {
      const timer = setTimeout(() => {
        setLinhasVisiveis((prev) => prev + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [linhasVisiveis, linhas.length]);

  const carregando = linhas.length === 0 || loading;

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <Avatar
            sx={{
              bgcolor: theme.palette.info.light,
              color: theme.palette.info.main,
              width: 36,
              height: 36,
              mr: 1
            }}
          >
            <PsychologyAltIcon />
          </Avatar>
          <Typography variant="subtitle1" sx={{ color: theme.palette.text.secondary }}>
            {title}
          </Typography>
        </Box>

        {carregando ? (
          <Box sx={{ maxHeight: 400, overflowY: 'auto', pr: 1 }}>
            <Table size="small">
              <TableBody>
                {Array.from({ length: 5 }, (_, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ border: 0 }}>
                      <Skeleton variant="text" width="100%" height={16} />
                      <Skeleton variant="text" width="80%" height={16} sx={{ mt: 1 }} />
                      <Skeleton variant="text" width="90%" height={16} sx={{ mt: 1 }} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ) : (
          <Box sx={{ maxHeight: 400, overflowY: 'auto', pr: 1 }}>
            <Table size="small">
              <TableBody>
                {linhas.slice(0, linhasVisiveis).map((linha, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ border: 0, whiteSpace: 'pre-wrap' }}>
                      <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
                        <Typewriter
                          words={[linha.trim()]}
                          typeSpeed={20}
                          deleteSpeed={0}
                          delaySpeed={0}
                          cursor={false}
                        />
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default InsightCard;
